import * as ActionTypes from '../constants/ActionTypes'
import { getRequest } from './http'

export function loading() {
  return {
    type: ActionTypes.LOADING_CHANGE
  }
}

export function setData(items, name) {
  return {
    type: ActionTypes.DATA,
    name: name,
    items: items
  }
}

const getChilds = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    getRequest(data, "progress").then(
    (response) => {
      dispatch(setData(response.data.childs, 'users'));
      dispatch(loading());
    },
    (err) => {
      dispatch(loading());
      if (err.response.status === 401) {
        dispatch(setData(true, 'error401'));
      }else{
        dispatch(setData(true, 'error'));
      }
    }
    );
  }
};

export default {
  getChilds
}
